import React from "react";
import {ShippingMethodHeader} from './ShippingMethodHeader';
import {ShippingMethodRow} from './ShippingMethodRow';


export const GroupedShippingMethods = ({totalShippingByLabel, shippingFees, shippingMethods}) => {
  let canBeGrouped = [];

  if (shippingFees !== undefined) {
    shippingFees.forEach((fee, index) => {
      canBeGrouped[index] = true;

      const firstItem = fee.items[0];

      // bundled items or single items are part of their own group, they must share their shipping methods
      if (firstItem.isBundled || fee.items.length === 1) {
        return;
      }

      const baseShippingMethodList = firstItem.shippingMethods;
      const baseShippingMethodString = JSON.stringify(baseShippingMethodList.sort());

      // do not group shipping methods if 2 items have different shipping methods
      for (let item of fee.items) {
        item.shippingMethods.sort();
        if (JSON.stringify(item.shippingMethods) !== baseShippingMethodString) {
          canBeGrouped[index] = false;
        }
      }

      // do not group if an item from another group have a common shipping method with the current group
      if (canBeGrouped[index]) {
        for (let k in shippingFees) {
          if (parseInt(k) !== parseInt(index)) {
            for (let otherItem of shippingFees[k].items) {
              for (let shippingMethod of baseShippingMethodList) {
                if (!otherItem.isBundled && otherItem.shippingMethods.indexOf(shippingMethod) >= 0) {
                  canBeGrouped[index] = false;
                }
              }
            }
          }
        }
      }
    });
  }

  return (
    <form className="form" action="#" id="change-shipping-method" method="POST">
      {shippingFees !== undefined && shippingFees.map((fee, index) => {
        fee.itemsCanBeGrouped = canBeGrouped[index];
        return <div key={index} style={{marginBottom: '15px'}}>
          <div className="card-wrapper">
            <ShippingMethodHeader totalShippingByLabel={totalShippingByLabel} fee={fee}
                                  shippingMethod={shippingMethods[fee.shippingMethodId]}/>
            <ShippingMethodRow fee={fee} shippingMethods={shippingMethods}/>
          </div>
        </div>
      })}
    </form>
  )
};
